import React, { useContext, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  CardBody,
  FormGroup,
  Label,
  Input,
  CardHeader,
  CardFooter,
  Button,
} from "reactstrap";
import { toast } from "react-toastify";
import validator from "validator";
import Axios from "axios";
import { Redirect } from "react-router-dom";
import { UserContext } from "../../context/UserContext";

const Test3 = () => {
  const context = useContext(UserContext);
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState(false);
  // const [password,setPassword]=useState('')
  const logindata = {
    email: "",
  };
  const handleFormSubmit = (e) => {
    e.preventDefault();
    checklogin();
  };
  const checklogin = async () => {
    if (email === "") {
      toast.error("Please Enter valid Credentials", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
      return;
    } else if (!validator.isEmail(email)) {
      toast.error("Please Enter valid Email", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
      return;
    }
    logindata.email = email;
    await Axios.post("Login/checklogin", { logindata })
      .then((res) => {
        if (res.data.status === "200" && res.data.exist === "true") {
          toast.error("You are already Register,Please Login", {
            position: toast.POSITION.BOTTOM_LEFT,
          });
          setEmail("");
          return res;
        } else if (res.data.status === "200" && res.data.exist === "false") {
          toast.success("Otp sent to " + res.data.email, {
            position: toast.POSITION.BOTTOM_LEFT,
          });
           context.setUser({otpemail:email})
           console.log(otp)
            setOtp(true);
        }
      })
      .catch((error) => {
        console.log("error123", error);
      });
  };
  if(context.user?.otpemail)
  {
	return<Redirect to="/test4"/>
  }
  return (
    <div>
      <Container className="text-center">
        <Row>
          <Col lg={6} className="offset-lg-3 mt-5">
            <Card>
              <Form onSubmit={handleFormSubmit}>
                <CardHeader className="">SignUp here</CardHeader>
                <CardBody>
                  <FormGroup row>
                    <Label for="email" sm={3}>
                      Email
                    </Label>
                    <Col sm={9}>
                      <Input
                        type="email"
                        name="email"
                        id="email"
                        placeholder="provide your email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </Col>
                  </FormGroup>
                </CardBody>
                <CardFooter>
                  <Button type="submit" block color="primary">
                    Register
                  </Button>
                </CardFooter>
              </Form>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Test3;
